const APIKEY = 'AIzaSyBSBtCJmcx5DSEYOsAzL1CyI4CgRofgSEA';

export default APIKEY;